import { Pipe, PipeTransform } from '@angular/core';

import { NgxMaskPipe } from 'ngx-mask';

@Pipe({
    name: 'phone',
    standalone: false
})
export class PhonePipe implements PipeTransform {
  constructor(private maskPipe: NgxMaskPipe) {}

  transform(value: any): string {
    return this.maskPipe.transform(value, '000-000-0000');
  }
}
